import { getToken } from './helpers';

const client = (endpoint, { body, ...customConfig } = {}, method, fileResponse = false) => {
  const isBodyFormData = body && body instanceof FormData;
  const headers = !isBodyFormData ? { 'Content-type': 'application/json' } : {};

  const token = getToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const config = {
    method: method || (body ? 'POST' : 'GET'),
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers
    }
  };

  if (body) {
    config.body = isBodyFormData ? body : JSON.stringify(body);
  }

  const url = `${process.env.REACT_APP_API_ENDPOINT}/v3`;
  return fetch(`${url}/${endpoint}`, config)
    .then(async (response) => {
      if (response.status === 401) {
        window.location.href = '/golfclub-admin/logout';
      }
      if (response.ok) {
        try {
          if (fileResponse) {
            const blob = await response.blob();
            const file = window.URL.createObjectURL(blob);
            window.location.assign(file);
          } else {
            const data = await response.json();
            return Promise.resolve({ data });
          }
        } catch {
          return Promise.resolve({ data: null });
        }
      }

      let error = null;
      try {
        error = await response.json();
      } catch {}

      return Promise.resolve({
        error: error?.message
          ? error
          : {
              message:
                config.method === 'GET'
                  ? 'Informationen kunde inte hämtas'
                  : 'Informationen kunde inte sparas'
            }
      });
    })
    .catch((e) =>
      // Sentry.captureException(e);
      Promise.resolve({ error: { message: e.message } })
    );
};

// const logout = () => window.localStorage.removeItem('');

export default client;
